module.exports = __webpack_public_path__ + "image/no-data.dff524a.png";